import { defineWidgetCore } from "../../widgetDefinition";
import { resolveTemplate } from "../../Utils/resolveTemplate";
import dayjs from "dayjs";
import type { PlayerNoteNonSeriesEntry, PlayerNotesNonSeriesResponse, PlayerNotesComponentSpec, WidgetResponseSpec } from "../../Processing/types";
import { renderPlayerNotes } from "../../PDF/renderers/playerNotesPdfRenderer";

const EMPTY_RESPONSE: WidgetResponseSpec = { widget_id: "", series: [] };

export const playerNotesCore = defineWidgetCore<PlayerNotesComponentSpec>({
  process(spec, response) {
    const s = spec;
    const misc = s.player_notes_builder_misc;
    const res = response ?? EMPTY_RESPONSE;
    const raw = res.non_series_response as PlayerNotesNonSeriesResponse | null;
    const noteList: PlayerNoteNonSeriesEntry[] = Array.isArray(raw?.notes) ? raw!.notes : [];

    const entries = noteList.map((n) => ({
      text: n.notes,
      noteId: n.note_id,
      playerId: n.player_id,
      playerName: n.player_name ?? null,
      // The author of a note can be deleted, so the backend sends null.
      authorName: n.author_name ?? "Unknown",
      authorEmail: n.author_email,
      date: n.timestamp ? dayjs(n.timestamp).format("MMM D") : undefined,
    }));

    return {
      type: "player_notes",
      spec: s,
      notes: {
        label: s.display?.title || "Player Notes",
        noteIds: misc?.noteIds ?? [],
        searchPattern: misc?.searchPattern,
        entries,
      },
    };
  },
  pdf: {
    buildSnapshot({ processed, slicerValues }) {
      if (processed.type !== "player_notes") return null;
      const { notes } = processed;
      return {
        type: "player_notes",
        label: notes.label == null ? null : resolveTemplate(notes.label, slicerValues).resolved,
        entries: notes.entries.map((e) => ({
          playerName: e.playerName ?? null,
          authorName: e.authorName ?? null,
          date: e.date ?? null,
          text: e.text,
        })),
      };
    },
    render({ snapshot, rect, scale }) {
      if (snapshot.type !== "player_notes") return null;
      return renderPlayerNotes(snapshot, rect, scale);
    },
  },
});
